import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep';

import InputWithButton from './InputWithButton';

const YouTubeField = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ url, setUrl ] = useState("");
	const [ is_valid, setIsValid ] = useState(false);
	const [ is_error, setIsError ] = useState(false);

	const name = props?.name ?? false;

	if(name === false) return null;

	const getThumb = () => {
		url.match(/(http:|https:|)\/\/(player.|www.)?(youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|videos\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
		const video_id = RegExp.$6;
		const video_url = `https://www.youtube.com/embed/${video_id}`;
		const r = url.match(/t=(.*?)s\&?/);
		const e = url.match(/e=(.*)s/);
		let url_info = '&showinfo=0&controls=0&rel=0';
		if(r && r[1] != undefined) url_info+='&start='+r[1];	// start time parameter
		if(e && e[1] != undefined) url_info+='&end='+e[1];		// end time parameter

		$.get(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${video_id}`, (res) => {
			setIsValid(true);
			setIsError(false);

			props.change(name, {
				url:video_url,
				youtube_id:video_id,
				caption:res.title,
				thumbnail:res.thumbnail_url,	//'https://i.ytimg.com/vi/'+video_id+'/maxresdefault.jpg'
				width:res.width,
				height:res.height,
				twidth:res.thumbnail_width,
				theight:res.thumbnail_height,
				type:'youtube',
			})
		}, 'JSON').fail((err) => {
			setIsValid(false);
			setIsError(err.responseText);
			console.error("YouTube returned the following error:", err.responseText)
		});
	};

	const change = (k, v) => {
		setIsError(false);
		if(v != url) setIsValid(false);

		setUrl(v);
	};

	let _props = { ...props };
	if(_props.errors == undefined) _props.errors = {};
	if(is_error) _props.errors[name] = "Error: Enter a valid YouTube URL";
	_props.error_msg_position_class = props?.error_msg_position_class ?? 'is_floating';

	if(_props.placeholder == undefined) {
		_props.placeholder = props?.placeholder ?? i18n("Insert the YouTube URL");
		_props.autotranslate_placeholder = false;
	}

	let classes = props?._class ?? {};
	if(classes.other == undefined) {
		classes.other = 'gui_url_input';
	} else {
		classes.other += ` gui_url_input`;
	}

	return (
		<InputWithButton
			{..._props}
			_class={classes}
			label_props={{
				_class:{ other:'in_bottom' },
			}}
			_type='url'
			submitColor={(is_valid) ? 'green' : false}
			submitIcon={(is_valid) ? 'knk-on' : 'knk-add-item'}
			change={change}
			onKeyAction={{ key:'Enter', action:getThumb }}
			onBlur={getThumb}
			onSubmit={getThumb}
		/>
	);
};

export default injectIntl(YouTubeField);